export const GEAR_ACTION_SEGMENT = "GEAR";
const __ = key => `${GEAR_ACTION_SEGMENT}_${key}`;
export const SET_GUEST_INFO = __("set-guest-info");
export const SET_DELIVERY = __("set-delivery");
export const SET_MEMBER_TYPE = __("set-member-type");
export const SET_BILLING_INFO = __("set-belling-info");
export const SET_SHIPPING_INFO = __("set-shipping-info");
export const SET_CONTACT_INFO = __("set-contact-info");
export const SET_DIFF_ADDR = __("set-diff-addr");
export const CLEAR_BILLING_INFO = __("clear-billing-info");
export const CLEAR_SHIPPING_INFO = __("clear-shipping-info");
export const CLEAR_CONTACT_INFO = __("clear-contact-info");
export const GEAR_CLEAR_CHECKOUT = __("clear-checkout");
export const SET_DISABLED_SKUIDS = __("set-disabled-skuIds");
export const SET_PICKUP_STORE = __("set-pickup-store");
export const setGuestInfoAction = data => ({
  type: SET_GUEST_INFO,
  ...data
});
export const setMemberTypeAction = memberType => ({
  type: SET_MEMBER_TYPE,
  memberType
});
export const setDeliveryAction = val => {
  return {
    type: SET_DELIVERY,
    ...val
  };
};
export const setBillingInfoAction = payload => {
  return {
    type: SET_BILLING_INFO,
    payload
  };
};
export const setShippingInfoAction = payload => {
  return {
    type: SET_SHIPPING_INFO,
    payload
  };
};
export const setContactInfoAction = payload => {
  return {
    type: SET_CONTACT_INFO,
    payload
  };
};
export const setDiffAddrAction = payload => {
  return {
    type: SET_DIFF_ADDR,
    payload
  };
};
export const clearBillingInfoAction = () => {
  return {
    type: CLEAR_BILLING_INFO
  };
};
export const clearShippingInfoAction = () => {
  return {
    type: CLEAR_SHIPPING_INFO
  };
};
export const clearContactInfoAction = () => {
  return {
    type: CLEAR_CONTACT_INFO
  };
};
export const clearGearCheckoutAction = () => {
  return {
    type: GEAR_CLEAR_CHECKOUT
  };
};
export const setDisabledSkuidsAction = data => {
  return {
    type: SET_DISABLED_SKUIDS,
    skuIds: data
  };
};
export const setPickupStoreAction = data => {
  return {
    type: SET_PICKUP_STORE,
    payload: data
  };
};
